import bg1 from "../../assets/bg-2.jpg";
import bg2 from "../../assets/bg-1.jpg";
import bg4 from "../../assets/bg-4.jpg";
import bg5 from "../../assets/bg-5.jpg";
import arch from "../../assets/arch.jpg";
import draw from "../../assets/draw.jfif";
import paint from "../../assets/paints.jpg";
import scl1 from "../../assets/scl1.jfif";

const blogs = [
  {
    title: "The Beauty of Nature",
    description:
      "Exploring the breathtaking landscapes and natural wonders of the world.",
    date: "2024-06-01",
    comments: 24,
    author: "John Doe",
    image: bg1,
  },
  {
    title: "Urban Architecture",
    description:
      "A deep dive into modern urban architecture and its impact on city life.",
    date: "2024-05-25",
    comments: 18,
    author: "Jane Smith",
    image: arch,
  },
  {
    title: "Mastering the Art of Drawing",
    description: "Tips and techniques for improving your drawing skills.",
    date: "2024-06-02",
    comments: 36,
    author: "Emily Brown",
    image: draw,
  },
  {
    title: "The World of Painting",
    description:
      "An exploration of different painting styles and famous painters.",
    date: "2024-05-20",
    comments: 22,
    author: "Michael Johnson",
    image: paint,
  },
  {
    title: "Sculpture: From Concept to Creation",
    description: "The process and passion behind creating stunning sculptures.",
    date: "2024-05-30",
    comments: 15,
    author: "Sarah Wilson",
    image: scl1,
  },
  {
    title: "Adventures in Travel Photography",
    description: "Capturing the essence of your travels through photography.",
    date: "2024-05-18",
    comments: 27,
    author: "Chris Evans",
    image: bg2,
  },
  {
    title: "Gardening Tips for Beginners",
    description: "Starting your own garden and maintaining it with ease.",
    date: "2024-06-01",
    comments: 33,
    author: "Jessica Taylor",
    image: bg4,
  },
  {
    title: "Healthy Cooking at Home",
    description: "Delicious and healthy recipes you can try at home.",
    date: "2024-06-02",
    comments: 40,
    author: "David Green",
    image: bg5,
  },
];

export default blogs;
